import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';

import { ANALYTICS_EVENTS } from '@nandosaus/constants';
import { Accordion } from '../accordion';
import { accordionItemsQuery, matrixBlockQuery } from '../../content/query-snippets';
import { analytics } from '../../analytics';
import { Container, Flex } from '../grid';
import { RichText } from '../typography/new';
import { BlockHeader } from '../block-header';

const AccordionBlock = ({ blockTitle, items }) => {
  return (
    <Container variant="featuredContent" my={{ xs: '64px', lg: '120px' }}>
      <BlockHeader heading={blockTitle} mb={{ xs: '36px', lg: '56px' }} />

      <Flex justifyContent="center">
        <Flex width={{ xs: 1, md: 8 / 12 }} flexDirection="column">
          {items.map(item => (
            <AccordionWrapper key={item.blockTitle}>
              <Accordion
                defaultExpanded={item.defaultExpanded}
                title={item.blockTitle}
                onStateChange={() =>
                  analytics.track(ANALYTICS_EVENTS.ACCORDION_BLOCK_CLICKED, {
                    text: item.blockTitle,
                  })
                }
              >
                <RichText keepMargins>{item.body}</RichText>
              </Accordion>
            </AccordionWrapper>
          ))}
        </Flex>
      </Flex>
    </Container>
  );
};

const AccordionWrapper = styled.div`
  border-top: 1px solid black;

  :last-child {
    border-bottom: 1px solid black;
  }
`;

AccordionBlock.query = `
  ... on contentMatrix_accordionBlock_BlockType {
    ${matrixBlockQuery}
    blockTitle
    ${accordionItemsQuery}
  }
`;

AccordionBlock.propTypes = {
  blockTitle: PropTypes.string.isRequired,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      blockTitle: PropTypes.string,
      body: PropTypes.string,
    })
  ).isRequired,
};

export { AccordionBlock };
